import React, { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Slot } from 'radix-ui'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useDeleteScenarioMutation } from '@/entities/scenario'

import { confirm } from '@/shared/components/ui/confirmer'
import { ampli } from '@/shared/lib/ampli'

export const DeleteScenario = ({
	scenarioId,
	children,
}: {
	scenarioId: string
	children: React.ReactNode
}) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const deleteScenarioMutation = useDeleteScenarioMutation({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['scenarios'],
			})
			queryClient.invalidateQueries({
				queryKey: ['scenarios-query-list'],
			})
		},
	})
	const deleteScenario = useCallback(
		async (scenarioId: string) => {
			ampli.scenarioDelete()
			const answer = await confirm({
				title: t('scenario.detete.confirm.title'),
				description: t('scenario.detete.confirm.subtitle'),
				actionText: t('general_delete'),
				cancelText: t('general_cancel'),
				ActionProps: {
					variant: 'destructive',
				},
			})
			if (answer) {
				toast.promise(deleteScenarioMutation.mutateAsync([scenarioId]), {
					loading: t('deleting.proccess', { defaultValue: 'Deleting...' }),
					success: t('deleting.success', {
						defaultValue: 'Deleted successfully',
					}),
					error: t('deleting.error', { defaultValue: 'Error while deleting' }),
				})
			}
		},
		[deleteScenarioMutation, t]
	)

	return (
		<Slot.Root onClick={() => deleteScenario(scenarioId)}>{children}</Slot.Root>
	)
}
